export interface Bq7ContainerM {
  capacityTEUFEUEmpty: string;
  capacityTEUFEUFull: string;
  containersWithinReach: string;
  ifNotWithinReachCapacity: string;
  fittingsForTEUFEU: string;
  recessedHolesShoes: string;
  stackWeightsTEU: string;
  stackWeightsFEU: string;
  hasContainerSpreader: string;
  hasContainerSpreaderComments: string;
  numberReeferPlugs: string;
}

export const initialBq6Container: Bq7ContainerM = {
  capacityTEUFEUEmpty: "",
  capacityTEUFEUFull: "",
  containersWithinReach: "",
  ifNotWithinReachCapacity: "",
  fittingsForTEUFEU: "",
  recessedHolesShoes: "",
  stackWeightsTEU: "",
  stackWeightsFEU: "",
  hasContainerSpreader: "",
  hasContainerSpreaderComments: "",
  numberReeferPlugs: "",
};

export function mapSqlToBq7ContainerForm(genInfo: any): Bq7ContainerM {
  return {
    capacityTEUFEUEmpty: genInfo?.CAPACITY_TEU_FEU_EMPTY || "",
    capacityTEUFEUFull: genInfo?.CAPACITY_TEU_FEU_FULL || "",
    containersWithinReach: genInfo?.CONTAINERS_WITHIN_REACH || "",
    ifNotWithinReachCapacity: genInfo?.IF_NOT_WITHIN_REACH_CAPACITY || "",
    fittingsForTEUFEU: genInfo?.FITTINGS_FOR_TEU_FEU || "",
    recessedHolesShoes: genInfo?.RECESSED_HOLES_SHOES || "",
    stackWeightsTEU: genInfo?.STACK_WEIGHTS_TEU || "",
    stackWeightsFEU: genInfo?.STACK_WEIGHTS_FEU || "",
    hasContainerSpreader: genInfo?.HAS_CONTAINER_SPREADER || "",
    hasContainerSpreaderComments: genInfo?.HAS_CONTAINER_SPREADER_COMMENTS || "",
    numberReeferPlugs: genInfo?.NUMBER_REEFER_PLUGS || "",
  };
}
